import type { FC } from 'react';
import {
  EuiButtonEmpty,
  EuiFlexGroup,
  EuiFlexItem,
  EuiPanel,
  EuiSpacer,
  EuiTitle,
} from '@elastic/eui';
import SpinnerEmbed from '@components/spinner/spinner-embed';
import { useDashboardStats } from '@data/useDashboardStats';
import RegistrationGraph from './graph';

interface DashboardProps {
  congressId: string;
}

const Dashboard: FC<DashboardProps> = ({ congressId }) => {
  const { dashboardStats, loading, error, refresh } =
    useDashboardStats(congressId);

  if (error) throw error;

  if (loading || dashboardStats == null) {
    return (
      <EuiPanel>
        <EuiTitle size="s">
          <h3>Dashboard</h3>
        </EuiTitle>
        <SpinnerEmbed show />
      </EuiPanel>
    );
  }

  return (
    <EuiPanel>
      <EuiFlexGroup
        direction="row"
        responsive={false}
        alignItems="baseline"
        justifyContent="spaceBetween">
        <EuiFlexItem>
          <EuiTitle size="s">
            <h3>Registration Dashboard</h3>
          </EuiTitle>
        </EuiFlexItem>
        <EuiFlexItem grow={false}>
          <EuiButtonEmpty iconType="refresh" onClick={refresh} />
        </EuiFlexItem>
      </EuiFlexGroup>
      <EuiSpacer size="m" />
      <RegistrationGraph stats={dashboardStats} />
    </EuiPanel>
  );
};

export default Dashboard;
